/* Altere este arquivo para obter seu portfólio pessoal */

// Para alterar as cores do portfólio globalmente, vá para o arquivo _globalColor.scss

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Renomeie para o nome do seu arquivo para animação personalizada

// Tela de Splash

const splashScreen = {
  enabled: true, // defina como false para desativar a tela de splash
  animation: splashAnimation,
  duration: 2000 // Defina a duração da animação conforme sua animação
};

// Resumo e Seção de Saudação

const illustration = {
  animated: true // Defina como false para usar SVG estático
};

const greeting = {
  username: "Artur Oliveira",
  title: "Oi, sou o Artur! Desenvolvedor FullStack",
  subTitle: emoji(
    "Desenvolvedor Full Stack desde 2021, com experiência em desenvolvimento frontend e backend, criando aplicações web e mobile e mantendo sistemas robustos e escaláveis."
  ),
  resumeLink: "../containers/greeting/resume.pdf", // Adicione o link para seu currículo
  displayGreeting: true // Defina como false para ocultar esta seção, padrão é true
};

// Links de Mídias Sociais

const socialMediaLinks = {
  github: "https://github.com/arturholiv",
  linkedin: "https://www.linkedin.com/in/arturholiv/",
  gmail: "arturholiv@gmail.com",
  whatsapp: "https://api.whatsapp.com/send/?phone=5531999146175&text=Ol%C3%A1,%20vim%20pelo%20seu%20portif%C3%B3lio%20e%20gostaria%20de%20conversar.&type=phone_number&app_absent=0",
  // Instagram, Twitter e Kaggle também são suportados nos links!
  // Para personalizar ícones e links sociais, ajuste src/components/SocialMedia
  display: true // Defina como true para exibir esta seção, padrão é false
};

// Seção de Habilidades 

const skillsSection = {
  title: "Habilidades",
  subTitle: "Linguagens de Programação e Tecnologias",
  skills: [
    emoji("⚡ Langgraph"),
    emoji("⚡ .NET"),
    emoji("⚡ React.js"),
    emoji("⚡ JavaScript e TypeScript"),
    emoji("⚡ Node.js"),
    emoji("⚡ Python"),
    emoji("⚡ Microsoft SQL Server")
  ],

  /* Certifique-se de incluir a classe Font Awesome correta para visualizar seu ícone
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "LangGraph",
      fontAwesomeClassname: "fas fa-project-diagram"
    },
    {
      skillName: "React.js",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: ".Net",
      fontAwesomeClassname: "fa fa-hashtag"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Wordpress",
      fontAwesomeClassname: "fab fa-wordpress"
    }
  ],
  display: true // Defina como false para ocultar esta seção, padrão é true
};

// Seção de Educação

const educationInfo = {
  display: true, // Defina como false para ocultar esta seção, padrão é true
  schools: [
    {
      schoolName: "Estácio de Sá",
      logo: require("./assets/images/estacio.png"),
      subHeader: "Análise e Desenvolvimento de Sistemas",
      duration: "fevereiro de 2022 - junho de 2024",
      desc: "Desenvolvimento de software, banco de dados e análise de sistemas. Além de outras metodologias de desenvolvimento de software.",
      descBullets: [
        "Banco de Dados",
        "Desenvolvimento de Software",
        "Análise de Sistemas"
      ]
    },
    {
      schoolName: "Trybe",
      logo: require("./assets/images/trybe.png"),
      subHeader: "Desenvolvimento de Software Web Full Stack",
      duration: "julho de 2021 - outubro de 2022",
      desc: "Aprendi sobre desenvolvimento de software, Frontend (Reactjs), Backend (Nodejs), Banco de Dados (MySQL) e outras bibliotecas e frameworks legais.",
      descBullets: [
        "Desenvolvimento de Software",
        "Banco de Dados",
        "Análise de Sistemas"
      ]
    },
    {
      schoolName: "Universidade Federal de Minas Gerais",
      logo: require("./assets/images/ufmg.png"),
      subHeader: "Matemática - trancado",
      duration: "março de 2023"
    }
  ]
};

// Suas 3 principais pilhas/experiências tecnológicas

const techStack = {
  viewSkillBars: false, // Defina como true para mostrar a Seção de Proficiência
  experience: [
    {
      Stack: "Frontend", // Insira a pilha ou tecnologia em que você tem experiência
      progressPercentage: "90%" // Insira a proficiência relativa em porcentagem
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Lógica de Programação",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Defina como true para exibir a seção de badges do codersrank, precisa alterar seu nome de usuário em src/containers/skillProgress/skillProgress.js:17:62, padrão é false
};

// Seção de experiência de trabalho

const workExperiences = {
  display: true, // Defina como true para mostrar a Seção de Experiências de Trabalho
  experience: [
    {
      role: "AI Engineer",
      company: "Plank",
      companylogo: require("./assets/images/plank.jpg"),
      date: "Março de 2025 - Presente",
      desc: "Como Engenheiro de IA na Plank, empresa do Vale do Silício, integro um time inovador dedicado ao desenvolvimento de softwares que incorporam inteligência artificial em diferentes etapas e funcionalidades. Atuo no design e implementação dessas soluções, colaborando com líderes técnicos e parceiros comerciais para entregar aplicações GenAI de alto impacto.",
      descBullets: [
        "Desenvolvimento de softwares com componentes de IA, utilizando LangGraph, React.js e Node.js.",
        "Participação no Programa Plank AI Accelerator, com foco em engenharia avançada de IA e entrega de projetos reais.",
        "Colaboração com equipes multidisciplinares para solucionar desafios complexos e impulsionar a inovação em IA."
      ]
    },
    {
      role: "Desenvolvedor Full Stack",
      company: "CAPYS",
      companylogo: require("./assets/images/capys.png"),
      date: "Maio de 2023 - Março de 2025",
      desc: "Atualmente, atuo como desenvolvedor Fullstack, focado na resolução de bugs em aplicações web.",
      descBullets: [
        "Criação de um projeto interno para a substituição da Twilio.",
        "Utilização de .Net, SQL Server, React, Angular.js e Node.js para melhorias e correção de bugs."
      ]
    },
    {
      role: "Estagiário de Desenvolvimento de Software",
      company: "Líder Aviação",
      companylogo: require("./assets/images/lider.png"),
      date: "Junho de 2022 - Maio de 2023",
      desc: "Desenvolvimento Back-End utilizando C# e ASP.NET MVC.",
      descBullets: [
        "Atuação em projeto de gerenciamento de aeronaves.",
        "Resolução de bugs e implementação de melhorias.",
        "Interação com o banco de dados Oracle PL/SQL."
      ]
    },
    {
      role: "Monitor de Matemática",
      company: "UFOP - Universidade Federal de Ouro Preto",
      companylogo: require("./assets/images/ufop.png"),
      date: "Março de 2020 - Novembro de 2020",
      desc: "Auxílio a alunos em suas dúvidas de matemática.",
      descBullets: [
        "Elaboração de exercícios e aulas para alunos de graduação",
        "Comunicação",
        "Matemática"
      ]
    }
  ]
};

/* Sua Seção de Código Aberto para Ver Seus Projetos Pinned no Github
Para saber como obter a chave do github, veja o readme.md */

const openSource = {
  showGithubProfile: "true", // Defina true ou false para mostrar o perfil de contato usando Github, padrão é true
  display: false // Defina false para ocultar esta seção, padrão é true
};

// Alguns grandes projetos em que você trabalhou

const bigProjects = {
  title: "Meus Projetos",
  subtitle: "Alguns projetos que eu participei ou desenvolvi",
  projects: [
    {
      image: require("./assets/images/kindeed.png"),
      projectName: "Kindeed",
      projectDesc:
        "Projeto autoral de uma plataforma de envio de arquivos, artigos e páginas web para o Kindle. Feito em React.js, Node.js e MySQL.",
      footerLink: [
        {
          name: "Visitar o site",
          url: "https://kindeed.com.br/"
        }
        // você pode adicionar botões extras aqui.
      ]
    },
    //{
      //image: require("./assets/images/wupper.png"),
      //projectName: "Wupper",
      //projectDesc:
        //"Site da Wupper, uma empresa de conexão entre criadores de conteúdos, marcas e audiência. Feito em Wordpress.",
      //footerLink: [
        //{
          //name: "Visitar o site",
          //url: "https://wupper.com.br/"
        //}
        // você pode adicionar botões extras aqui.
      //]
    //},
    {
      image: require("./assets/images/wp-ping.png"),
      projectName: "WP Ping",
      projectDesc: "Projeto autoral de uma api Node.js que utiliza a whatsapp-web.js, uma biblioteca de WhatsApp para NodeJS que se conecta através do navegador web do WhatsApp. Projeto feito para enviar mensagens de WhatsApp sem precisar utilizar a twilio."
    }
  ],
  display: true // Defina false para ocultar esta seção, padrão é true
};

// Seção de Conquistas
// Inclua certificados, palestras etc.

const achievementSection = {
  title: emoji("Conquistas e Certificações 🏆 "),
  subtitle:
    "Conquistas, Certificações, Cartas de Prêmio e Algumas Coisas Legais que eu fiz!",

  achievementsCards: [
    {
      title: "Finalista do Google Code-In",
      subtitle:
        "Primeiro paquistanês a ser selecionado como finalista do Google Code-in entre 4000 estudantes de 77 países diferentes.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Logo do Google Code-In",
      footerLink: [
        {
          name: "Certificação",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Carta de Prêmio",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Blog do Google Code-in",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Ação do Google Assistant",
      subtitle:
        "Desenvolvi uma Ação do Google Assistant chamada JavaScript Guru que está disponível em 2 bilhões de dispositivos em todo o mundo.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Logo da Ação do Google Assistant",
      footerLink: [
        {
          name: "Ver Ação do Google Assistant",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "Desenvolvedor de Aplicativos PWA",
      subtitle:
        "Concluí a Certificação da SMIT para Desenvolvimento de Aplicativos PWA",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "Logo PWA",
      footerLink: [
        {name: "Certificação", url: ""},
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "Com paixão por desenvolver coisas legais, eu amo conversar e ensinar o que eu aprendi.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "Eu amo compartilhar meu conhecimento limitado e receber um badge de palestrante 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "Eu amo conversar sobre mim e tecnologia",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Sinta-se à vontade para baixar meu currículo",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contato ☎️"),
  subtitle: "Vamos nos conectar!",
  number: "(31) 99914-6175", // Adicione seu número de telefone aqui
  email_address: "arturholiv@gmail.com",
  linkedin: "https://www.linkedin.com/in/arturholiv"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
